import links from "@/links/links";

export default {
  actions: {
    FETCH(agencyId) {
      return this.get(links.MAJORITY_FETCH(), {
        dataKey: "hydra:member",
      });
    },
  },
};
